module.exports = __webpack_public_path__ + "static/img/mckinsey-company.eecde7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/mckinsey-company.png
// module id = fRa6
// module chunks = 0